import { useQuery } from "@tanstack/react-query";
import { from, unwrap } from "@vixio/data";
import type { BudgetRow } from "./api";

/** Dados dos painéis do Início: ficam fora das telas para que elas carreguem sob demanda. */
export function useBudget(orgId: string) {
  return useQuery({
    queryKey: ["ai_gateway", "budget", orgId],
    queryFn: () => unwrap<BudgetRow[]>(from("ai_gateway", "v_budget").select("*").eq("org_id", orgId)),
  });
}
